import dayjs from 'dayjs';

import { weeklyPlannerDayDisplayFormat } from '~libs/dayjs';

import { Column } from '~components/table-view';

// Columns for Rescheduled Appointments
export const rescheduledColumns: Column[] = [
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
    deriveValue: (row) => row.client?.full_name ?? '',
  },
  {
    id: 'date',
    header: 'New Date',
    type: 'text',
    deriveValue: ({ date }) => (date && dayjs(date).isValid() ? dayjs(date).format(weeklyPlannerDayDisplayFormat) : 'N/A'),
  },
  {
    id: 'user.full_name',
    header: 'User',
    type: 'text',
    deriveValue: (row) => row.user?.full_name ?? '',
  },
];

// Columns for Cancelled Appointments
export const cancelledColumns: Column[] = [
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
    deriveValue: (row) => row.client?.full_name ?? '',
  },
  {
    id: 'date',
    header: 'Cancelled Date',
    type: 'text',
    deriveValue: ({ date }) => (date && dayjs(date).isValid() ? dayjs(date).format(weeklyPlannerDayDisplayFormat) : 'N/A'),
  },
  {
    id: 'user.full_name',
    header: 'User',
    type: 'text',
    deriveValue: (row) => row.user?.full_name ?? '',
  },
];
